import { render, staticRenderFns } from "./AboutCustomView.vue?vue&type=template&id=598bc00c&"
import script from "./AboutCustomView.vue?vue&type=script&lang=js&"
export * from "./AboutCustomView.vue?vue&type=script&lang=js&"
import style0 from "./AboutCustomView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports